<template>
  <mdb-container class="gp-has-header">

    <data-table v-show="!showEditor" ref="formList" :add-handler="create"
                :click-handler="editForm"
                :columns="columns"
                add-label="New Form"
                data-source="/customForm/list"
                page-title="Forms"
                show-add-button/>

    <div v-if="showEditor" class="text-left">
      <mdb-btn rounded size="sm" @click="showList">
        <mdb-icon icon="arrow-left"/>
        Back to List
      </mdb-btn>
      <mdb-input id="form-name" v-model="currentForm.name" label="Name"/>
      <mdb-input id="urlName" v-model="currentForm.urlName" label="URL Path"/>
      <gp-select :dataObj="currentForm" :possible-values="audienceTypes" :required="true"
                 label="Audience" propertyName="audience"/>
      <mdb-input id="confirmationText" type="textarea" :rows="3" v-model="currentForm.confirmationText" label="Confirmation Text When Form Submitted"/>
      <div class="form-check">
        <input aria-label="New Responses to Admin Dashboard" class="form-control form-check-input"
               id="dashboard-responses"
               type="checkbox"
               v-model="currentForm.dashboardResponses"/>
        <label for="dashboard-responses">Add new responses to admin dashboard?</label>
      </div>
      <div v-if="currentForm.id">
        <label>Form URL:</label>
        <div>
          <a :href="currentUrl" target="_blank">{{currentUrl}}</a> <mdb-icon icon="external-link"/>
        </div>

      </div>
      <mdb-btn :disabled="!currentForm.urlName || !currentForm.name || !currentForm.audience"
               @click="save">
        <mdb-icon icon="save"/>
        Save
      </mdb-btn>
      <mdb-btn v-if="currentForm.id"
               @click="$router.push('/custom-fields/form/' + currentForm.id + '?return=/custom/forms/' + currentForm.id)">
        <mdb-icon icon="clipboard-list"/>
        Manage Fields
      </mdb-btn>

      <mdb-btn @click="deleteModal=true" icon="trash" color="danger">
        Delete
      </mdb-btn>
    </div>
    <yes-no-modal v-if="deleteModal" @yes="deleteForm" @no="deleteModal=false" additional-text="This will also remove all responses!"/>

  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import dataTable from "../common/DataTable";
import Vue from "vue";
import YesNoModal from "../common/YesNoModal";
import gpSelect from "../common/GPSelect";

import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCol,
  mdbContainer,
  mdbFileInput,
  mdbIcon,
  mdbInput,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbRow,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
  mdbTooltip,
  mdbTreeview,
  mdbTreeviewItem,
  mdbView
} from 'mdbvue';

export default {
  name: "custom-form-admin",
  display: "Admin System Pages",
  order: 1,
  components: {
    YesNoModal,
    mdbContainer,
    mdbBtn,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardImage,
    mdbMask,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter,
    mdbIcon,
    mdbTreeview,
    mdbTreeviewItem,
    mdbBadge,
    mdbView,
    mdbTooltip,
    mdbInput,
    mdbFileInput,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    dataTable,
    gpSelect
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    },
    settings: function () {
      return this.$store.state.settings
    },
    currentUrl: function() {
      return this.settings.frontEndUrl + "/form/" + this.currentForm.urlName
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.$store.dispatch("setExecuting", true)
      api.get("/customForm/getOne/" + this.$route.params.id).then(
        (results) => {
          this.currentForm = results.data
          this.showEditor = true
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  },
  data() {
    return {
      forms: [],
      currentForm: {
        id: null, redirect: "", urlName: ""
      },
      showEditor: false,
      showViewer: false,
      deleteModal: false,
      columns: [
        {label: "Name", field: "name"},
        {label: "URL", field: "urlName"}
      ],
      audienceTypes: [
        {text: "Logged-In User", value: "LOGGED_IN_USER"},
        {text: "Public", value: "PUBLIC"}
      ]
    }
  },
  methods: {
    create: function () {
      this.currentForm = {
        urlName: "", name: "", id:null, audience: ""
      }
      this.showEditor = true
      Vue.nextTick().then(() => {
        let el = document.getElementById("form-name")
        if (el) el.focus()
      })

    },
    deleteForm: function () {
      this.deleteModal = false
      this.$store.dispatch("setExecuting", true)
      api.delete("/customForm/details/" +  this.currentForm.id).then(
        (details) => {
          this.showList()
          this.$notify.success({message: "Form deleted successfully."})
        },
        (error) => {
          this.$notify.error({message: "Error saving document."})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },

    save: function () {
      this.$store.dispatch("setExecuting", true)
      api.post("/customForm/details", this.currentForm).then(
        (details) => {
          if (!this.currentForm.id) {
            this.currentForm = details.data
          }
          this.$notify.success({message: "Form saved successfully."})
        },
        (error) => {
          this.$notify.error({message: "Error saving document."})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    editForm: function (form) {
      this.currentForm = form
      this.showEditor = true
    },
    showList: function () {
      this.showEditor = false
      if (this.$route.params.id) this.$router.replace("/custom/forms")
      this.$store.dispatch("setDataTableReload", true)
    }
  }

}
;
</script>
